import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome/index.es';
import {faTrashAlt, faCheck, faSpinner} from '@fortawesome/free-solid-svg-icons';
import InputField from 'components/form/input-field';
import DateField from 'components/form/date-field';
import MoneyField from 'components/form/money-field';
import DeleteTransactionModal from 'modules/budget/components/budget-modals/delete-transaction-modal';
import { inject, observer } from 'mobx-react';
import { withNamespaces } from 'react-i18next';

@withNamespaces()
@inject('store')
@observer
class TransactionItem extends Component {
    constructor(props) {
        super(props);

        const { description, date, amount } = props.transaction;
        this.state = {
            dirty: false,
            description: description || '',
            date,
            amount,
            previousAmount: amount,
        };

        this.showDeleteModal = this.showDeleteModal.bind(this);
        this.hideDeleteModal = this.hideDeleteModal.bind(this);
        this.updateTransaction = this.updateTransaction.bind(this);
        this.handleChange = this.handleChange.bind(this);
    }

    handleChange(e) {
        const { name, value } = e.target;

        this.setState({
            [name]: value,
            dirty: true,
        });
    }

    showDeleteModal() {
        this.setState({ showModal: true });
    }

    hideDeleteModal() {
        this.setState({ showModal: false });
    }

    updateTransaction() {
        const { loading } = this.props.transaction;

        if (!loading) {
            this.props.transaction.requestEdit(this.state)
                .then(response => {
                    this.setState({
                        dirty: false,
                        previousAmount: response.data.amount,
                    })
                });
        }
    }

    render() {
        if (this.state.killSelf) {
            return null;
        }

        const { t, transaction } = this.props;
        const { loading } = transaction;
        const { dirty, description, date, amount } = this.state;
        const { isMobile } = this.props.store.app;

        // Show a Modal on click.
        const deleteTransactionModal = this.state.showModal ? (
            <DeleteTransactionModal
                transaction={this.props.transaction}
                onDismiss={this.hideDeleteModal}
            />
        ) : null;

        return (
            <Fragment>
                <tr className={`row-details ${dirty ? 'row-dirty' : ''}`}>
                    <td className="hidden-sm hidden-xs" colSpan={2}>
                        <InputField name="description"
                                    parentClassName="no-margin"
                                    value={description}
                                    onChange={this.handleChange}
                                    placeholder={t('BUDGET.TRANSACTION.DESCRIPTION')}
                        />
                    </td>
                    <td className="hidden-sm hidden-xs">
                        <span className="no-date-margin">
                            <DateField name="date"
                                       hidePre={true}
                                       value={date}
                                       onChange={this.handleChange}
                                       restrictToMonth={true}
                            />
                        </span>
                    </td>
                    <td colSpan={isMobile ? 5 : 1}>
                        <MoneyField name="amount"
                                    parentClassName="no-margin"
                                    value={amount}
                                    onChange={this.handleChange}
                        />
                    </td>
                    <td>
                        <div className="btn-group">
                            {dirty ? (
                                <button style={{width: '35px'}} className={`btn btn-xs btn-default ${loading ? 'loading-btn' : 'pen-btn'}`} onClick={this.updateTransaction} disabled={loading}>
                                    {loading ?
                                        <FontAwesomeIcon className="edit-pen" icon={faSpinner} pulse={true} /> :
                                        <FontAwesomeIcon className="edit-pen" icon={faCheck} fixedWidth={true} />
                                    }
                                </button>
                            ) : (
                                <button className="btn btn-xs btn-default times-btn" onClick={this.showDeleteModal}>
                                    <FontAwesomeIcon className="remove-times" icon={faTrashAlt} fixedWidth={true} />
                                </button>
                            )}
                        </div>
                    </td>
                </tr>
                {deleteTransactionModal}
            </Fragment>
        )
    }
}

TransactionItem.propTypes = {
    /** Instance of TransactionItem from store */
    transaction: PropTypes.any.isRequired,
};

export default TransactionItem;



// WEBPACK FOOTER //
// ./src/modules/budget/components/budget-table/transaction-item.js